export const secondsToISO = (totalSeconds: number | undefined) => {
  if (!totalSeconds) {
    return 'PT0S';
  }

  const minutes = Math.floor((totalSeconds / 60) % 60);

  const seconds = Math.floor(totalSeconds % 60);

  const duration = `PT${minutes}M${seconds}S`;

  return duration;
};
